import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Popover from 'react-bootstrap/Popover';

export const ActionBarOverlay = React.forwardRef((
    props, ref) => {
    const {
        children,
        show,
        preRender,
        id,
        title,
        onClick,
        width,
        style,
        className,
        ...rest
    } = props;
    // In order to have position an popover offscreen we should not apply the styles from the popover
    // That's why we use an empty array in that case.
    const adjustedStyles = preRender && !show ? { } : { ...style, width };
    const adjustedClassName = preRender && !show ? classNames(className, 'position-offscreen') : className;
    return (
        <Popover ref={ref}
            id={id}
            onClick={onClick}
            {...rest}
            style={adjustedStyles}
            className={adjustedClassName}
        >
            <Popover.Title className='popover-title'>{title}</Popover.Title>
            <Popover.Content className='popover-content'>
                {children}
            </Popover.Content>
        </Popover>
    );
});

ActionBarOverlay.defaultProps = {
    placement: 'bottom',
    width: 250,
};

ActionBarOverlay.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    preRender: PropTypes.bool,
    show: PropTypes.bool,
    width: PropTypes.oneOf([100, 150, 200, 250, 300, 350, 400, 450, 500]),
};

export default ActionBarOverlay;
